
//字符串转ArrayBuff
export const stringToBuffer = (str) =>{
  var buf = new ArrayBuffer(str.length); // 每个字符占1字节
  var bufView = new Uint8Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

// 十六进制字符串转ArrayBuffer
export const hexToArrayBuffer = (hex) => {
    hex = hex.replace(/\s/g, '')
    if (hex.length % 2 !== 0) throw new Error('无效的十六进制字符串')
    
    const buffer = new Uint8Array(hex.length / 2)
    for (let i = 0; i < hex.length; i += 2) {
      buffer[i/2] = parseInt(hex.substr(i, 2), 16)
    }
    return buffer
 }

 export const arrayBuffer2hex = (arrayBuffer) => {  
	return Array.prototype.map.call(new Uint8Array(arrayBuffer), x => ('00' + x.toString(16)).slice(-2)).join('');
}